var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66699C5.39199 1.66699 1.66699 5.39199 1.66699 10.0003C1.66699 14.6087 5.39199 18.3337 10.0003 18.3337C14.6087 18.3337 18.3337 14.6087 18.3337 10.0003C18.3337 5.39199 14.6087 1.66699 10.0003 1.66699ZM14.167 12.992L12.992 14.167L10.0003 11.1753L7.00866 14.167L5.83366 12.992L8.82533 10.0003L5.83366 7.00866L7.00866 5.83366L10.0003 8.82533L12.992 5.83366L14.167 7.00866L11.1753 10.0003L14.167 12.992Z",
    fill: "#D3D6DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.f89a73dfae33a3b8b00c4b9da54b2362.svg";
export { ForwardRef as ReactComponent };